export default Object.freeze({
    "WEB_AND_MAIL": "WEB_AND_MAIL",
    "WEB": "WEB",
    "MAIL": "MAIL",
    "NO_NOTIFICATIONS": "NO_NOTIFICATIONS"
});